<template>
   <transition name="el-zoom-in-top">
      <div class="content-wrapper">
         <!-- Content Header (Page header) -->
         <section class="content-header">
            <!-- <h1>Shop Item Page<small><i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1> -->
            <ol class="breadcrumb">
               <li>
                  <router-link to="/"> <i class="ti-home"></i></router-link>
               </li>
                <li><router-link to="/admin">Admin</router-link></li>
                <li><router-link to="/admin/publisher">Publishers</router-link></li>
                <li class="active">Publisher Domains</li>
            </ol>
         </section>
         <!-- Main content -->
         <section class="content">
            <div class="box" style="padding:30px;">
               <div class="">
                 <div class="add-domain-button float-right"> <router-link :to="`${'/admin/publisher/'  + publishersUuid +  '/' + publishersId + '/domain/add/' }`"><el-button type="primary"><i class="el-icon-circle-plus"></i></el-button></router-link>

                </div>
               </div>
               <!-- <el-button :plain="true" @click="dialogFormVisible = true">open a Form nested Dialog</el-button> -->
               <ul class="cart-items width-custom width-100 pull-left pl-60 pr-30 pb-0 pt-0 container-fluid">
                  <li class="cart-items-labels visible-lg-block visible-md-block row">
                     <span class="col-md-6 text-muted small">Domains</span>
                     <!-- <span class="col-md-2 text-muted small text-center">quantity</span>  -->
                     <!-- <span class="col-md-4 text-muted small text-right">price</span> -->
                  </li>
                  <li v-for="option in publishers" class="row">
                     <span class="cart-image col-xs-12 col-sm-12 col-md-2">
                        <router-link :to="`${'/admin/publisher/' + option.publisher.uuid + '/domain/edit/' + option.id}`" class="h5" >
                          <avatar class = "" :username="option.name" :size='50' color="#fff"></avatar>
                          <!-- <img alt="product description" src="http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg"> -->
                            
                          </router-link>
                     </span>
                     <div class="cart-item-right col-md-10 col-xs-12 col-sm-12">
                        <div class="row">
                           <span class="cart-description col-xs-12 col-md-5">
                              <router-link :to="`${'/admin/publisher/' + option.publisher.uuid + '/domain/edit/' + option.id}`" class="h5" >{{`${option.name}`}}</router-link>
                              <!-- <span class="cart-item-price h5 text-muted">$ 33.00</span> -->
                           </span>
                           <span class="col-md-5 col-sm-12 text-right">
                              <!-- <span class="cart-price pull-right">$330.00 <a class="cart-remove" href="#"> -->
                              <router-link :to="`${'/admin/publisher/' + option.publisher.uuid + '/domain/edit/' + option.id}`" class ="hoverColor"><span class="ti-pencil-alt pull-right mt-5 ml-10">
                                 </span>
                              </router-link>
                           </span>
                           </span>
                        </div>
                     </div>
                  </li>
               </ul>
               <div style="clear:both"></div>
            </div>
         </section>
         <!-- /.content -->
      </div>
   </transition>
</template>
<script>
   import axios from 'axios'
   import Avatar from 'vue-avatar'
  export default {
    data () {
      return {
        name: 'ShopHome',
        publishers: [],
        publishersId: this.$route.params.id,
        publishersUuid: this.$route.params.uuid,
      }
    },
    beforeCreate: function () {
      this.$nextTick(function () {
        axios.get(BASE_URL + 'v1/publishers/' + this.$route.params.uuid + '/domains/')
          .then(response => {
            console.log(response.data.length);
            this.publishers = response.data;
            if(response.data.length >= 1){
              
            }
          })
          .catch(error => {
            if (error.response.status == 400) {
              if (error.response.data) {
                console.log(error.response.data)
              }
            }
          })
      })
    },
    methods: {

    },

  
  components: {
    Avatar
  }
   
   }
</script>
<style>
    .publishers-all {
    width: 70%;
  }

  .add-domain-button {
    position:relative;
    bottom:10px;
  }

  .width-custom {
    width: 100%;
  }

  .publishers-name {
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: clip;
    height: 15px;
  }
</style>


// WEBPACK FOOTER //
// PublisherInfo.vue?45f4b6ca